<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Por qué ubicarme'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div class="m-b-25">
    La ubicación es uno de los factores decisivos durante la
    búsqueda de un centro de estudios. Por ello, la utilizamos
    para mostrarte resultados e información más relevante. De
    ser necesario, puedes cambiarla en cualquier momento. No te
    preocupes, respetamos tu privacidad.
  </div>

  <div class="text-center">
    <button
      mat-raised-button
      class="bg-naranja-sunedu rounded-full"
      (click)="handleClose()">
      Cerrar
    </button>
  </div>

</lib-modal-container>
